<div class="container-fluid bg-white">
  <div class="row">
    <div class="sidebar border border-right col-md-3 col-lg-2 p-0 bg-body-tertiary">
      <div class="d-flex flex-column flex-shrink-0 p-3 bg-body-tertiary" style="width: 100%;">

        <!-- Back button-->
        <div href="/" class="d-flex align-items-center mb-3 mb-md-0 me-md-auto link-body-emphasis text-decoration-none pb-4">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left-circle" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
          </svg>
          <span class="fs-6">&nbsp; <a (click)="goBack()">Back</a> </span>
        </div>

        <!-- Steps -->
        <ul class="nav nav-pills flex-column mb-auto">
          @for (section of this.sections; track section.tabId) {
          <li class="nav-item" role="presentation">
            <a href="#" class="nav-link" [class.disabled]="section.disabled" [class.active]="section.active" [style.color]="section.disabled ? 'silver' : ''" [id]="section.tabId" data-bs-toggle="tab" [attr.data-bs-target]="'#' + section.id" type="button" role="tab" [attr.aria-controls]="section.id" [attr.aria-selected]="section.show" (click)="this.onSectionClick(section)">
              <div style="display: flex;">
                <div style="width: 100%;">
                  {{section.label}}
                  @if (!section.isValid() && !section.disabled){
                  <span title="Requires attention"> *</span>
                  }
                </div>
                @if (section.isFlagged()){
                <div style="padding-left: 8px;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#C8102E" class="bi bi-flag-fill" viewBox="0 0 16 16">
                    <path d="M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12 12 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A20 20 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a20 20 0 0 0 1.349-.476l.019-.007.004-.002h.001" />
                  </svg>
                </div>
                }
              </div>
            </a>
          </li>
          }
        </ul>
      </div>
    </div>
    <main class="col-md-9 ms-sm-auto col-lg-10 px-md-4" style="padding-right: 12px !important; height: calc(100vh - 64px);">
      <!-- Header -->
      <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 border-bottom">
        <h1 class="h2" style="white-space: nowrap;">{{this.title}}</h1>
        <div style="padding-right: 24px;">
          {{this.status}}
        </div>
      </div>

      <div class="tab-content" id="myTabContent">
        <!-- Sections -->
        <ng-content></ng-content>
      </div>
    </main>
  </div>
</div>
